/* @flow */
import LimitedClassesModalContainer from './LimitedClassesModalContainer';

export default LimitedClassesModalContainer;
